<div *ngIf="loader" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loader">

  <!-- Header -->
  <div class="evm-header mb-4">
    <a class="evm-back-btn"
      [routerLink]="['/', langSrcSrv.current.shortCode, 'evaluation', route.snapshot.params.langTgt]">
      <i class="fa-solid fa-arrow-left"></i>
      <span translate>Retour</span>
    </a>
    <h2 class="evm-page-title" translate>Test de positionnement</h2>
    <div class="evm-header-spacer"></div>
  </div>

  <!-- Card -->
  <div class="evm-card mx-auto">

    <div class="evm-card-icon">
      <i class="fa-solid fa-brain"></i>
    </div>

    <h3 class="evm-card-title" translate>Prêt.e à commencer ?</h3>

    <p class="evm-card-desc" translate>
      Ce test de positionnement d'environ 5 minutes évalue ta compréhension orale et écrite
      afin de personnaliser ton parcours d'apprentissage selon ton niveau.
    </p>

    <!-- Conditions checkbox (only if already started learning) -->
    <div
      *ngIf="displayAcceptConditions()"
      class="evm-conditions"
      (click)="acceptConditions = !acceptConditions">
      <div class="evm-conditions-check">
        <i class="fa-solid fa-check" *ngIf="acceptConditions"></i>
      </div>
      <div class="evm-conditions-text" translate>
        J'accepte de commencer mon apprentissage au niveau déterminé par ce test de positionnement.
      </div>
    </div>

    <button
      class="evm-btn-start"
      [disabled]="displayAcceptConditions() && !acceptConditions"
      (click)="start()"
      translate>
      Commencer le test
    </button>

  </div>

</div>
